export default function (Component) {
            Component.options.skeletonTemplate = "\n<div class=\"skeleton\">&nbsp;</div>\n"
        }